import { FC } from 'react';
import { useCollectiveAccountsData } from './collective-accounts.hook';

/**
 * CollectiveAccounts component
 * @description Content for the Reports CollectiveAccounts flow.
 * @link https://www.figma.com/file/16ideRW6XB1s57uA93ppSl/Manager--%7C-File-for-development?type=design&node-id=2118-412813&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const CollectiveAccounts: FC = () => {
  const { stages, currentStage } = useCollectiveAccountsData();

  return stages && currentStage ? stages[currentStage] : null;
};

export { CollectiveAccounts };
